import React from "react";
import Slider from "react-slick";
import "./BloodDonationSlider.css";

// Blood compatibility data
const bloodCompatibility = {
  "A+": { receive: ["A+", "A-", "O+", "O-"], donate: ["A+", "AB+"] },
  "A-": { receive: ["A-", "O-"], donate: ["A+", "A-", "AB+", "AB-"] },
  "B+": { receive: ["B+", "B-", "O+", "O-"], donate: ["B+", "AB+"] },
  "B-": { receive: ["B-", "O-"], donate: ["B+", "B-", "AB+", "AB-"] },
  "O+": { receive: ["O+", "O-"], donate: ["O+", "A+", "B+", "AB+"] },
  "O-": { receive: ["O-"], donate: ["Everyone"] },
  "AB+": { receive: ["Everyone"], donate: ["AB+"] },
  "AB-": { receive: ["AB-", "A-", "B-", "O-"], donate: ["AB+", "AB-"] },
};

const BloodDonationSlider = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 600,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2500,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 2 } },
      { breakpoint: 600, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <section className="donation-learn-section">
      <h2 className="donation-learn-title">Learn About Blood Donation</h2>
      <Slider {...settings}>
        {Object.keys(bloodCompatibility).map((group) => (
          <div key={group} className="blood-card">
            <div className="blood-type-header">{group}</div>

            <div className="tag-label">🩸 Can Receive From</div>
            <div className="blood-tags">
              {bloodCompatibility[group].receive.map((type, idx) => (
                <span key={idx} className="tag receive">
                  {type}
                </span>
              ))}
            </div>

            <div className="tag-label">🎁 Can Donate To</div>
            <div className="blood-tags">
              {bloodCompatibility[group].donate.map((type, idx) => (
                <span key={idx} className="tag donate">
                  {type}
                </span>
              ))}
            </div>
          </div>
        ))}
      </Slider>
    </section>
  );
};

export default BloodDonationSlider;
